import _ from "lodash"
import { common, responsiveCSSStyle } from "./styles"

/**
 * Override property of one xAxis item
 * See API doc: https://api.highcharts.com/highstock/xAxis
 * @param xAxis
 */
function applyXAxisPlugin(xAxis) {
  _.unset(xAxis, "gridLineColor")
  _.unset(xAxis, "gridLineWidth")

  _.set(xAxis, "labels.rotation", -45)
  _.set(xAxis, "labels.style", responsiveCSSStyle())

  _.set(xAxis, "lineColor", common.lightGrey)
  _.set(xAxis, "lineWidth", 1)
  _.set(xAxis, "tickColor", common.lightGrey)

  // update extremes if necessary
  // _.set(xAxis, "events.setExtremes", (e) => {
  //   console.log("Event: ", e)
  //   console.log("This: ", this)
  //   console.log("Event#dataMin: ", new Date(e.dataMin))
  //   console.log("Event#dataMax: ", new Date(e.dataMax))
  //   console.log("Event#min: ", new Date(e.min))
  //   console.log("Event#max: ", new Date(e.max))
  // })
}

/**
 * Custom xAxis
 * See API doc: https://api.highcharts.com/highstock/xAxis
 * @param chartOpts
 * @returns {*}
 */
export default function xAxisPlugin(chartOpts) {
  if (!chartOpts.xAxis) {
    return chartOpts
  }

  if (_.isArray(chartOpts.xAxis)) {
    chartOpts.xAxis.forEach(applyXAxisPlugin)
    return chartOpts
  }
  // simple axis apply
  applyXAxisPlugin(chartOpts.xAxis)
  return chartOpts
}
